import React, { Fragment } from "react";
import Contactus from "../components/Contactus";
import { Helmet } from "react-helmet";
function ContactUs(){
    return(
        <Fragment>
            <Helmet>
                <title>
          Contact HelperJi for Office Cleaning & Housekeeping Services Near You
        </title>

        <meta
          name="description"
          content="Get in touch with HelperJi, a professional commercial cleaning & housekeeping company, for office cleaning services & trained housekeeping manpower support near you."
        />

        <meta
          name="keywords"
          content="Contact Commercial Cleaning Services, Professional Commercial Cleaning Company, Office Cleaning Services Contact, Corporate Cleaning Services, Corporate Housekeeping Services, Housekeeping Manpower Services, Housekeeping Manpower Agency, Professional Cleaning Services Provider"
        />

        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="daily" />
        <meta name="allow-search" content="yes" />
        <meta name="copyright" content="Helper Ji" />

        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href="https://www.helperji.in/contact-us"
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta
          property="og:title"
          content="Contact HelperJi for Office Cleaning & Housekeeping Services Near You"
        />
        <meta
          property="og:description"
          content="Get in touch with HelperJi, a professional commercial cleaning & housekeeping company, for office cleaning services & trained housekeeping manpower support near you."
        />
        <meta
          property="og:image"
          content="https://www.helperji.in/assets/img/Banner.jpg"
        />
        <meta property="og:site_name" content="Helper Ji" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.helperji.in/contact-us"
        />

        {/* ===== TWITTER META ===== */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@helperji_" />
        <meta name="twitter:creator" content="@helperji_" />
        <meta
          name="twitter:title"
          content="Contact HelperJi for Office Cleaning & Housekeeping Services Near You"
        />
        <meta
          name="twitter:description"
          content="Get in touch with HelperJi, a professional commercial cleaning & housekeeping company, for office cleaning services & trained housekeeping manpower support near you."
        />
        <meta
          name="twitter:image"
          content="https://www.helperji.in/assets/img/Banner.jpg"
        />

        {/* ===== ORGANIZATION SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Helper Ji",
            "alternateName": "Helper Ji",
            "url": "https://www.helperji.in/contact-us",
            "logo": "https://www.helperji.in/assets/img/logo.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "7800780095",
              "contactType": "customer service",
              "areaServed": "IN",
              "availableLanguage": ["en", "Hindi"]
            },
            "sameAs": [
              "https://www.facebook.com/helperjiofficial",
              "https://x.com/helperji_",
              "https://www.instagram.com/helperji_official/"
            ]
          }
          `}
        </script>

        {/* ===== LOCAL BUSINESS SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Helper Ji",
            "image": "https://www.helperji.in/assets/img/logo.png",
            "@id": "https://www.helperji.in/contact-us",
            "url": "https://www.helperji.in/contact-us",
            "telephone": "+91-7800780095",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "H-159, VDS Building, Suite No. 301A, Sector 63, Noida - 201301",
              "addressLocality": "Noida",
              "postalCode": "201301",
              "addressCountry": "IN"
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
              ],
              "opens": "09:00",
              "closes": "19:00"
            },
            "sameAs": [
              "https://www.facebook.com/helperjiofficial",
              "https://x.com/helperji_",
              "https://www.instagram.com/helperji_official/"
            ]
          }
          `}
        </script>

        {/* ===== WEBPAGE SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "https://www.helperji.in/contact-us",
            "name": "Contact HelperJi for Office Cleaning & Housekeeping Services Near You",
            "description": "Get in touch with HelperJi, a professional commercial cleaning & housekeeping company, for office cleaning services & trained housekeeping manpower support near you."
          }
          `}
        </script>

        {/* ===== CONTACT PAGE SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "url": "https://www.helperji.in/contact-us",
            "name": "Contact Us",
            "mainEntity": {
              "@type": "Organization",
              "name": "Helper Ji",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-7800780095",
                "contactType": "customer support"
              }
            }
          }
          `}
        </script>
          <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
            </Helmet>
            <Contactus />
        </Fragment>
    )
}

export default ContactUs;